import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
var SkeletonLoader = /*#__PURE__*/ forwardRef(function SkeletonLoader(param, ref) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: "lapel-skeleton",
        ref: ref,
        children: children
    });
});
export { SkeletonLoader };

//# sourceMappingURL=SkeletonLoader.js.map